module.exports = __webpack_public_path__ + "img/yx-bg1.c814e0af.png";